<template>
  <div>
    <Modal v-model="showModal" title="编辑校区" width="800">
      <Form :model="zoneForm" :label-width="160" ref="zoneForm" :rules="zoneRules">
        <FormItem label="名称" prop="name">
          <Input v-model="zoneForm.name" type="text" placeholder="校区名称"/>
        </FormItem>
        <FormItem label="地址" prop="address">
          <Input v-model="zoneForm.address" type="text" placeholder="校区地址"/>
        </FormItem>
        <FormItem label="电话" prop="phone">
          <Input v-model="zoneForm.phone" type="text" placeholder="联系电话"/>
        </FormItem>
        <FormItem label="联系人" prop="contact">
          <Input v-model="zoneForm.contact" type="text" placeholder="联系人"/>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input type="textarea" v-model="zoneForm.remark" placeholder="备注"/>
        </FormItem>
          <FormItem label="一对一请假时间限制" prop="cancellimitone">
              距开课&nbsp;<Input v-model="zoneForm.cancellimitone" type="text" placeholder="" style="width:50px" />&nbsp;小时内不能请假
          </FormItem>
          <FormItem label="班课请假时间限制" prop="cancellimitclass">
              距开课&nbsp;<Input v-model="zoneForm.cancellimitclass" type="text" placeholder=""  style="width:50px" />&nbsp;小时内不能请假
          </FormItem>
          <FormItem label="请假审核人" prop="cancelby" >
              <RadioGroup v-model="zoneForm.cancelby">
                  <Radio :label="1" >校区管理员</Radio>
                  <Radio :label="2" >教师</Radio>
              </RadioGroup>
          </FormItem>
      </Form>
      <div slot="footer">
        <Button size="small" type="primary" @click="saveZone('zoneForm')">确定</Button>
        <Button size="small" type="default" @click="modalcancle">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    name:'zone_form',
    data(){
      return{
        showModal:false,
        id:'',
        zoneForm:{
          name:'',
          address:'',
          phone:'',
          contact:'',
          remark:'',
          cancellimitone:null,
          cancellimitclass:null,
          cancelby:1
        },
        zoneRules:{
          name:[{required:true,message:'请输入校区名',trigger:'blur'}],
          cancellimitone:[{type:'integer',required:true,message:'请输入一对一请假限制时长',trigger:'blur',transform(value) {
            if (value === null || value === ""){
              return null;
            }
            return Number(value);
            }}],
          cancellimitclass:[{type:'integer',required:true,message:'请输入班课请假限制时长',trigger:'blur',transform(value) {
              if (value === null || value === ""){
                return null;
              }
              return Number(value);
            }}],
          // address:[{required:true,message:'请输入地址',trigger:'blur'}],
        }
      }
    },
    methods:{
      getZoneDetail(){
        this.$api.zone.getZoneDetail({id:this.id}).then(res=>{
          if(res.state=="ok"){
            this.zoneForm=res.zone;
          }else{
            this.$Message.error(res.msg);
          }
        })
      },
      saveZone(name){
        let self = this;
        self.$refs[name].validate((valid) => {
          if (valid) {
            this.$api.zone.saveZone(this.packagingFormData()).then(res => {
              if (res.state == "ok") {
                this.$Message.success("保存成功");
                this.$refs.zoneForm.resetFields();
                this.showModal = false
                this.$emit("refresh");
              } else {
                this.$Message.error(res.msg);
                this.showModal = false
              }
            })
          }else{
            this.$Message.error("表单验证不通过！");
          }
        })
      },
      modalcancle(){
        this.$refs.zoneForm.resetFields();
        this.showModal=false
      },
      packagingFormData(){
        let postFormData = {};
        for (var i in this.zoneForm) {
          if (this.zoneForm.hasOwnProperty(i)) {
              postFormData['zone.'+i] = this.zoneForm[i];
          }
        }
        postFormData['zone.id']=this.id
        return postFormData;
      },
      init(){
        this.$refs.zoneForm.resetFields()
      }
    }
  }
</script>
